import $ from 'jquery'

$(document).ready(function() {
  $('.carousel').carousel()
})
